import React, { useState } from "react";
import API_URL from "../../services/api";
import "./AddBook.css";

const AddBook = () => {
  const initialBook = {
    title: "",
    author: "",
    genre: "",
    quantity: "",
    publisher: "",
    publicationYear: "",
    isbn: "",
    language: "",
    description: "",
    frontCover: null,
    backCover: null,
    isForSale: false,
    price: "",
    saleStock: "",
  };

  const [book, setBook] = useState(initialBook);

  const genres = [
    "Fiction",
    "Non-fiction",
    "Fantasy",
    "Science Fiction",
    "Mystery",
    "Horror",
    "Romance",
    "Adventure",
    "Biography",
    "Autobiography",
    "Self-help",
    "History",
    "Physics",
    "Chemistry",
    "Biology",
    "Computer Science",
    "Algebra",
    "Geometry",
    "Calculus",
    "Statistics",
    "Geography",
    "Civics",
    "Economics",
    "Programming",
    "Web Development",
    "Networking",
    "Databases",
    "English",
    "Urdu",
    "Grammar",
    "Literature",
  ];

  const handleChange = (e) => {
    setBook({
      ...book,
      [e.target.name]: e.target.value,
    });
  };

  const handleFile = (e) => {
    setBook({
      ...book,
      [e.target.name]: e.target.files[0],
    });
  };

  const addBook = async () => {
    if (!book.title || !book.author || !book.genre) {
      alert("Please fill required fields.");
      return;
    }

    if (book.isForSale) {
      if (!book.price || !book.saleStock) {
        alert("Please enter selling price and sale stock.");
        return;
      }
    }

    const formData = new FormData();

    Object.keys(book).forEach((key) => {
      if (book[key] !== null) {
        formData.append(key, book[key]);
      }
    });

    try {
      const res = await fetch(`${API_URL}/api/books/add`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "Failed to add book.");
        return;
      }

      alert("Book Added Successfully!");

      setBook(initialBook);

      // Reset file inputs
      const fileInputs = document.querySelectorAll(
        ".add-book-file-input"
      );

      fileInputs.forEach((input) => {
        input.value = "";
      });
    } catch (err) {
      console.log("ADD BOOK ERROR:", err);
      alert("Server Error");
    }
  };

  return (
    <div className="add-book-page">
      <div className="add-book-card">

        {/* ================= HEADER ================= */}

        <div className="add-book-header">
          <h1>Add New Book</h1>
          <p>
            Add a new book to the library collection
          </p>
        </div>

        {/* ================= FORM ================= */}

        <div className="add-book-form">

          {/* Title */}

          <div className="form-group">
            <label>
              Book Title <span>*</span>
            </label>

            <input
              className="add-book-input"
              name="title"
              placeholder="Enter book title"
              value={book.title}
              onChange={handleChange}
            />
          </div>

          {/* Author */}

          <div className="form-group">
            <label>
              Author <span>*</span>
            </label>

            <input
              className="add-book-input"
              name="author"
              placeholder="Enter author name"
              value={book.author}
              onChange={handleChange}
            />
          </div>

          {/* Genre */}

          <div className="form-group">
            <label>
              Genre <span>*</span>
            </label>

            <select
              className="add-book-input"
              name="genre"
              value={book.genre}
              onChange={handleChange}
            >
              <option value="">
                Select Genre
              </option>

              {genres.map((genre, index) => (
                <option
                  key={index}
                  value={genre}
                >
                  {genre}
                </option>
              ))}
            </select>
          </div>

          {/* Quantity */}

          <div className="form-group">
            <label>Quantity</label>

            <input
              className="add-book-input"
              type="number"
              min="0"
              name="quantity"
              placeholder="Enter quantity"
              value={book.quantity}
              onChange={handleChange}
            />
          </div>

          {/* Publisher */}

          <div className="form-group">
            <label>Publisher</label>

            <input
              className="add-book-input"
              name="publisher"
              placeholder="Enter publisher"
              value={book.publisher}
              onChange={handleChange}
            />
          </div>

          {/* Publication Year */}

          <div className="form-group">
            <label>Publication Year</label>

            <input
              className="add-book-input"
              type="number"
              min="0"
              name="publicationYear"
              placeholder="e.g. 2024"
              value={book.publicationYear}
              onChange={handleChange}
            />
          </div>

          {/* ISBN */}

          <div className="form-group">
            <label>ISBN</label>

            <input
              className="add-book-input"
              name="isbn"
              placeholder="Enter ISBN"
              value={book.isbn}
              onChange={handleChange}
            />
          </div>

          {/* Language */}

          <div className="form-group">
            <label>Language</label>

            <input
              className="add-book-input"
              name="language"
              placeholder="e.g. English, Urdu"
              value={book.language}
              onChange={handleChange}
            />
          </div>

          {/* Description */}

          <div className="form-group full-width">
            <label>Description</label>

            <textarea
              className="add-book-textarea"
              name="description"
              placeholder="Enter book description"
              value={book.description}
              onChange={handleChange}
            />
          </div>

          {/* ================= SALE SECTION ================= */}

          <div className="sale-section full-width">

            <div className="sale-header">

              <div>
                <h3>Book Sale</h3>

                <p>
                  Make this book available for sale
                </p>
              </div>

              <label className="switch">

                <input
                  type="checkbox"
                  checked={book.isForSale}
                  onChange={(e) =>
                    setBook({
                      ...book,
                      isForSale: e.target.checked,
                    })
                  }
                />

                <span className="slider"></span>

              </label>

            </div>

            {book.isForSale && (
              <div className="sale-fields">

                <div className="form-group">
                  <label>
                    Selling Price (Rs.) <span>*</span>
                  </label>

                  <input
                    className="add-book-input"
                    type="number"
                    min="0"
                    name="price"
                    placeholder="Enter selling price"
                    value={book.price}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>
                    Sale Stock <span>*</span>
                  </label>

                  <input
                    className="add-book-input"
                    type="number"
                    min="0"
                    name="saleStock"
                    placeholder="Enter sale stock"
                    value={book.saleStock}
                    onChange={handleChange}
                  />
                </div>

              </div>
            )}

          </div>

          {/* ================= COVER IMAGES ================= */}

          <div className="cover-section full-width">

            <h3>Book Covers</h3>

            <div className="cover-grid">

              {/* Front Cover */}

              <div className="file-box">

                <div className="file-icon">
                  📕
                </div>

                <label>
                  Front Cover
                </label>

                <p>
                  Upload the front cover
                </p>

                <input
                  className="add-book-file-input"
                  type="file"
                  name="frontCover"
                  accept="image/*"
                  onChange={handleFile}
                />

                {book.frontCover && (
                  <small>
                    {book.frontCover.name}
                  </small>
                )}

              </div>

              {/* Back Cover */}

              <div className="file-box">

                <div className="file-icon">
                  📗
                </div>

                <label>
                  Back Cover
                </label>

                <p>
                  Upload the back cover
                </p>

                <input
                  className="add-book-file-input"
                  type="file"
                  name="backCover"
                  accept="image/*"
                  onChange={handleFile}
                />

                {book.backCover && (
                  <small>
                    {book.backCover.name}
                  </small>
                )}

              </div>

            </div>

          </div>

          {/* ================= BUTTON ================= */}

          <div className="button-container full-width">

            <button
              className="add-book-button"
              onClick={addBook}
            >
              Add Book
            </button>

          </div>

        </div>

      </div>
    </div>
  );
};

export default AddBook;